import React, { useContext, useEffect, useState } from 'react';
import Chatbot from 'react-chatbot-kit';
import generateConfig from './config';
import MessageParser from './MessageParser';
import ActionProvider from './ActionProvider';
import { AppContext } from '../../context/appContext';
import useRecalculateChatMeasures from '../../hooks/useRecalculateChatMeasures';


const Chat = (props: any) => {
  const {chatHistory, widgetConfig} = useContext(AppContext);
  useRecalculateChatMeasures();

  console.log('chatHistory', chatHistory)
  return (
    !!chatHistory.length &&
      <Chatbot
        config={generateConfig(widgetConfig)}
        headerText={
          widgetConfig.customText?.chatHeaderText ||
          "Complete the following questionnaire to find the best quote to suit your needs."
        }
        messageParser={MessageParser}
        actionProvider={ActionProvider}
        messageHistory={chatHistory}
        validator={(value: string) => {
          return !!value
        }}
      />
  );
};

export default Chat;
